import React, { useRef, useState, useEffect } from 'react'
import { DRIVER_TYPES } from '../../shared/types'
import { Tooltip } from '@mui/material'
import classNames from 'classnames'

import styles from './DriverTypeSelector.module.scss'

interface IDriverTypeSelectorProps {
  selectedType: string
  onSelect: (type: string) => void
}

const DriverTypeSelector = ({
  selectedType,
  onSelect,
}: IDriverTypeSelectorProps) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const handleTypeSelect = (type: string) => {
    onSelect(type)
    setShowDropdown(false)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false)
      }
    }

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showDropdown])

  return (
    <div className={styles.selectorWrapper}>
      <Tooltip title="Select driver type" placement="top">
        <button
          ref={triggerRef}
          className={styles.triggerInput}
          onMouseDown={() => setShowDropdown(!showDropdown)}
        >
          {selectedType ? (
            <span className={styles.selectedText}>{selectedType}</span>
          ) : (
            <span className={styles.placeholder}>Select type</span>
          )}
        </button>
      </Tooltip>

      {showDropdown && (
        <div
          ref={dropdownRef}
          className={classNames(styles.dropdown, {
            [styles.visible]: showDropdown,
          })}
        >
          {DRIVER_TYPES.map((type) => (
            <div
              key={type}
              className={classNames(styles.dropdownItem, {
                [styles.selected]: type === selectedType,
              })}
              onClick={() => handleTypeSelect(type)}
            >
              {type}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default DriverTypeSelector
